/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "Wo5dMEP_BbI01",
    title: "THE BATMAN",
    youtubeID: "mqqft2x_Aa4",
    videoLength: "2:38",
    videoThumbnail: "http://i3.ytimg.com/vi/mqqft2x_Aa4/hqdefault.jpg",
    likes: "1.2M",
    views: "50M",
    category: "action",
    channelName: "Warner Bros. Pictures",
    channelThumbnail:
      "https://yt3.ggpht.com/ytc/AKedOLTUnZtaiWtHHHFxqilQey0x3Psd8rRtiIDxyYgHCg=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCjmJDM5pRKbUlVIzDYYWb6g",
    subscribers: "10.4M",
    description:
      "It's not just a call… It's a warning. ",
  },
  {
    _id: "Wo5dMEP_BbI20",
    title: "Free Solo - Trailer | National Geographic",
    youtubeID: "urRVZ4SW7WU",
    videoLength: "2:27",
    videoThumbnail: "http://i3.ytimg.com/vi/urRVZ4SW7WU/hqdefault.jpg",
    likes: "39K",
    views: "9.5M",
    category: "documentary",
    channelName: "National Geographic",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AKedOLTdh4vj3oGXpCXT3lMqha9_Qq4-JvMBlpztnHvi_mI=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCpVm7bg6pXKo1Pr6k5kxG9A",
    subscribers: "19.7M",
    description: "From award-winning documentary filmmaker E. Chai Vasarhelyi and world-renowned photographer and mountaineer Jimmy Chin, comes FREE SOLO, a stunning, intimate and unflinching portrait of free soloist climber Alex Honnold, as he prepares to achieve his lifelong dream: climbing the face of the world’s most famous rock... the 3,200ft El Capitan in Yosemite National Park… without a rope.",
  },
  {
    _id: "Wo5dMEP_BbI07",
    title: "I'm Your Man Trailer #1 (2021)",
    youtubeID: "xXz9jIKojDk",
    videoLength: "2:15",
    videoThumbnail: "http://i3.ytimg.com/vi/xXz9jIKojDk/hqdefault.jpg",
    likes: "668",
    views: "98K",
    category: "romance",
    channelName: "Movieclips Indie",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AKedOLQFOK12LirznJh9qx78vRztKxchZEI8eb4by89y3A=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCLyYEq4ODlw3OD9qhGqwimw",
    subscribers: "2.1M",
    description: "Check out the I'm Your Man Official Trailer starring Dan Stevens and Maren Eggert! Let us know what you think in the comments below.",
  },
  {
    _id: "Wo5dMEP_BbI05",
    title: "WRATH OF MAN ",
    youtubeID: "EFYEni2gsK0",
    videoLength: "2:40",
    videoThumbnail: "http://i3.ytimg.com/vi/EFYEni2gsK0/hqdefault.jpg",
    likes: "140K",
    views: "32M",
    category: "action",
    channelName: "MGM",
    channelThumbnail:
      "https://yt3.ggpht.com/ytc/AKedOLRacUS2qbBCdu6oUsOK_wrSz-HW0YP6bMdgSkaPwQ=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCf5CjDJvsFvtVIhkfmKAwAA",
    subscribers: "449K",
    description:
      "Jason Statham and director Guy Ritchie are back in action. Now playing in theaters",
  },
  {
    _id: "Wo5dMEP_BbI02",
    title: "SPIDER-MAN: NO WAY HOME",
    youtubeID: "ZYzbalQ6Lg8",
    videoLength: "3:04",
    videoThumbnail: "http://i3.ytimg.com/vi/ZYzbalQ6Lg8/hqdefault.jpg",
    likes: "1.6M",
    views: "39M",
    category: "action",
    channelName: "Marvel Entertainment",
    channelThumbnail:
      "https://yt3.ggpht.com/fGvQjp1vAT1R4bAKTFLaSbdsfdYFDwAzVjeRVQeikH22bvHWsGULZdwIkpZXktcXZc5gFJuA3w=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/c/marvel",
    subscribers: "18.4",
    description:
      "We started getting visitors… from every universe. Watch the official trailer for #SpiderManNoWayHome, exclusively in movie theaters December 17. ",
  },
  {
    _id: "Wo5dMEP_BbI18",
    title: "The Social Dilemma | Official Trailer | Netflix",
    youtubeID: "uaaC57tcci0",
    videoLength: "2:34",
    videoThumbnail: "http://i3.ytimg.com/vi/uaaC57tcci0/hqdefault.jpg",
    likes: "198K",
    views: "9.7M",
    category: "documentary",
    channelName: "Netflix",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AKedOLTZzZv60B1v76eOC7TsEYZD_TMH2-H5KeYxkfXGBQ=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCWOA1ZGywLbqmigxE4Qlvuw",
    subscribers: "23.2M",
    description: "We tweet, we like, and we share— but what are the consequences of our growing dependence on social media? As digital platforms increasingly become a lifeline to stay connected, Silicon Valley insiders reveal how social media is reprogramming civilization by exposing what's hiding on the other side of your screen.",
  },
  {
    _id: "Wo5dMEP_BbI11",
    title: "THE GIRL WITH THE DRAGON TATTOO - Official Trailer",
    youtubeID: "DqQe3OrsMKI",
    videoLength: "3:49",
    videoThumbnail: "http://i3.ytimg.com/vi/DqQe3OrsMKI/hqdefault.jpg",
    likes: "20K",
    views: "5.6M",
    category: "thriller",
    channelName: "Sony Pictures Entertainment",
    channelThumbnail: "https://yt3.ggpht.com/S4VWNJnJF_21DlC_tXhDYg6jyr4E9tJMlwn6kx49HPrh8uqNnQ3vZrIoDaaW2irhhsb-lTFQKA=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCz97F7dMxBNOfGYu3rx8aCw",
    subscribers: "6.29M",
    description: "Release Date: 21 December 2011 (United States) Disgraced journalist Mikael Blomkvist (Daniel Craig) accepts an invitation to surreptitiously investigate a forty year old unsolved murder on behalf of the victim's uncle, Swedish industrialist Henrik Vanger (Christopher Plummer).",
  },
  {
    _id: "Wo5dMEP_BbI08",
    title: "THE WORST PERSON IN THE WORLD",
    youtubeID: "w_cV1q02cyE",
    videoLength: "1:33",
    videoThumbnail: "http://i3.ytimg.com/vi/w_cV1q02cyE/hqdefault.jpg",
    likes: "272",
    views: "76K",
    category: "romance",
    channelName: "MUBI",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AKedOLTvVzNuHbwoZ3kpOASiyUkIikZJZp3WtsTT46X-wg=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCb6-VM5UQ4Czj_d3m9EPGfg",
    subscribers: "61.2K",
    description: "THE WORST PERSON IN THE WORLD. A wistful and life-affirming coming-of-age story about the quest for love and meaning in contemporary Oslo. Directed by Joachim Trier and starring Renate Reinsve, winner of the Best Actress award at the 2021 Cannes Film Festival.",
  },
  {
    _id: "Wo5dMEP_BbI13",
    title: "Badla | Trailer | Netflix",
    youtubeID: "xHWQiok-ei0",
    videoLength: "2:04",
    videoThumbnail: "http://i3.ytimg.com/vi/xHWQiok-ei0/hqdefault.jpg",
    likes: "21K",
    views: "1.5M",
    category: "thriller",
    channelName: "Netflix",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AKedOLTZzZv60B1v76eOC7TsEYZD_TMH2-H5KeYxkfXGBQ=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCWOA1ZGywLbqmigxE4Qlvuw",
    subscribers: "23.2M",
    description: "When Naina (played by Taapsee Pannu), gets caught in a web of accusations surrounding her lover's death, her lawyer helps her unravel the many threads around the crime.",
  },
  {
    _id: "Wo5dMEP_BbI09",
    title: "Set It Up | Official Trailer",
    youtubeID: "X-eRc9PF3TU",
    videoLength: "2:20",
    videoThumbnail: "http://i3.ytimg.com/vi/X-eRc9PF3TU/hqdefault.jpg",
    likes: "68K",
    views: "6.6M",
    category: "romance",
    channelName: "Netflix",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AKedOLTZzZv60B1v76eOC7TsEYZD_TMH2-H5KeYxkfXGBQ=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCWOA1ZGywLbqmigxE4Qlvuw",
    subscribers: "23.2M",
    description: "New York assistants, Harper (Zoey Deutch) and Charlie (Glen Powell), are used to going above and beyond for their high-powered (and highly demanding) bosses, Kristen (Lucy Liu) and Rick (Taye Diggs).",
  },
  {
    _id: "Wo5dMEP_BbI16",
    title: "14 Peaks: Nothing Is Impossible",
    youtubeID: "8QH5hBOoz08",
    videoLength: "1:54",
    videoThumbnail: "http://i3.ytimg.com/vi/8QH5hBOoz08/hqdefault.jpg",
    likes: "98K",
    views: "3.1M",
    category: "documentary",
    channelName: "Netflix",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AKedOLTZzZv60B1v76eOC7TsEYZD_TMH2-H5KeYxkfXGBQ=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCWOA1ZGywLbqmigxE4Qlvuw",
    subscribers: "23.2M",
    description: "Fearless Nepali mountaineer Nimsdai Purja embarks on a seemingly impossible quest to summit all 14 of the world’s 8,000-meter peaks in seven months.",
  },
  {
    _id: "Wo5dMEP_BbI10",
    title: "About Time - International Trailer",
    youtubeID: "u2PUMA6nFWk",
    videoLength: "2:59",
    videoThumbnail: "http://i3.ytimg.com/vi/u2PUMA6nFWk/hqdefault.jpg",
    likes: "5.9K",
    views: "1.8M",
    category: "romance",
    channelName: "Universal Pictures UK",
    channelThumbnail: "https://yt3.ggpht.com/xzhfSTAZeC6JmuvaYVwzZ5xYsDyP9XVa1nnhrB8rehII_LMi7FirSH8ISY0sENCceqYSjVaN4g=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCQLBOKpgXrSj3nPU-YC3K9Q",
    subscribers: "1.12M",
    description: "In UK Cinemas September 4, 2013",
  },
  {
    _id: "Wo5dMEP_BbI04",
    title: "Mortal Kombat (2021)",
    youtubeID: "NYH2sLid0Zc",
    videoLength: "2:30",
    videoThumbnail: "http://i3.ytimg.com/vi/NYH2sLid0Zc/hqdefault.jpg",
    likes: "381K",
    views: "17M",
    category: "action",
    channelName: "IGN",
    channelThumbnail:
      "https://yt3.ggpht.com/H_---ano_f27DOCejDhUdBMtBcxcv32MoXmFKQc_mBcxYSH4HPZTGuBUdm7UgI5VlutMOVX2=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCKy1dAqELo0zrOtPkf0eTMw",
    subscribers: "16.5M",
    description:
      "The Mortal Kombat movie reboot from director Simon McQuoid features the defenders of Earthrealm Liu Kang, Sonya Blade, Jax Briggs and more entering the Mortal Kombat tournament",
  },
  {
    _id: "Wo5dMEP_BbI17",
    title: "The Last Dance | Relive the Phenomenon | Netflix",
    youtubeID: "JQk2hJs2ToA",
    videoLength: "1:13",
    videoThumbnail: "http://i3.ytimg.com/vi/JQk2hJs2ToA/hqdefault.jpg",
    likes: "4.9K",
    views: "270K",
    category: "documentary",
    channelName: "Netflix",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AKedOLTZzZv60B1v76eOC7TsEYZD_TMH2-H5KeYxkfXGBQ=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCWOA1ZGywLbqmigxE4Qlvuw",
    subscribers: "23.2M",
    description: "The Last Dance, the critically acclaimed, must-see 10-part documentary series has arrived on Netflix.  Relive the phenomenon.",
  },
  {
    _id: "Wo5dMEP_BbI03",
    title: "Godzilla vs. Kong",
    youtubeID: "odM92ap8_c0",
    videoLength: "2:24",
    videoThumbnail: "http://i3.ytimg.com/vi/odM92ap8_c0/hqdefault.jpg",
    likes: "2.2M",
    views: "101M",
    category: "action",
    channelName: "Warner Bros. Pictures",
    channelThumbnail:
      "https://yt3.ggpht.com/H_---ano_f27DOCejDhUdBMtBcxcv32MoXmFKQc_mBcxYSH4HPZTGuBUdm7UgI5VlutMOVX2=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCjmJDM5pRKbUlVIzDYYWb6g",
    subscribers: "10.4M",
    description:
      "In theaters and streaming exclusively on @HBOMax* March 26.",
  },
  {
    _id: "Wo5dMEP_BbI14",
    title: "Drishyam Trailer",
    youtubeID: "ODhU_DCVXEI",
    videoLength: "3:07",
    videoThumbnail: "http://i3.ytimg.com/vi/ODhU_DCVXEI/hqdefault.jpg",
    likes: "11K",
    views: "1.2M",
    category: "thriller",
    channelName: "Viacom18 Studios",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AKedOLTrclvHT3l_soBvAhbfWT7H65kCHMQ7fU0No5kPjw=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCs56ffejFhWlCvlvRIdpb9Q",
    subscribers: "4.74",
    description: "Presenting the much awaited trailer of Drishyam, starring Ajay Devgn, Tabu and Shriya Saran.",
  },
  {
    _id: "Wo5dMEP_BbI12",
    title: "Parasite - Official Trailer (2019) ",
    youtubeID: "5xH0HfJHsaY",
    videoLength: "2:16",
    videoThumbnail: "http://i3.ytimg.com/vi/5xH0HfJHsaY/hqdefault.jpg",
    likes: "170K",
    views: "17M",
    category: "thriller",
    channelName: "IGN",
    channelThumbnail:
      "https://yt3.ggpht.com/H_---ano_f27DOCejDhUdBMtBcxcv32MoXmFKQc_mBcxYSH4HPZTGuBUdm7UgI5VlutMOVX2=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCKy1dAqELo0zrOtPkf0eTMw",
    subscribers: "16.5M",
    description: "Bong Joon Ho brings his singular mastery home to Korea in this pitch-black modern fairytale. Meet the Park Family: the picture of aspirational wealth. And the Kim Family, rich in street smarts but not much else.",
  },
  {
    _id: "Wo5dMEP_BbI19",
    title: "The Game Changers | Official Trailer",
    youtubeID: "iSpglxHTJVM",
    videoLength: "2:29",
    videoThumbnail: "http://i3.ytimg.com/vi/iSpglxHTJVM/hqdefault.jpg",
    likes: "17K",
    views: "17M",
    category: "documentary",
    channelName: "The Game Changers",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AKedOLQ6KbRPFMlxMl82tu_YzEioZzBOGsopC0RVPEAX=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCVxdMam-fljznK6JsMITlYQ",
    subscribers: "35.4K",
    description: "A UFC fighter learns everything he'd been taught about protein was a lie.",
  },
  {
    _id: "Wo5dMEP_BbI15",
    title: "SEARCHING - Official International Trailer",
    youtubeID: "9eccvs0b_oU",
    videoLength: "2:28",
    videoThumbnail: "http://i3.ytimg.com/vi/9eccvs0b_oU/hqdefault.jpg",
    likes: "2.5K",
    views: "822K",
    category: "thriller",
    channelName: "Sony Pictures Australia",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AKedOLRh4Yp8VvjDUBMu_8PFPgCd6lDK6eNQ0EtClVpi=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UCQ2zp9FmJzOG_JzUJ0A-FlQ",
    subscribers: "158K",
    description: "After David Kim (John Cho)'s 16-year-old daughter goes missing, a local investigation is opened and a detective is assigned to the case. But 37 hours later and without a single lead, David decides to search the one place no one has looked yet, where all secrets are kept today: his daughter's laptop.",
  },
  {
    _id: "Wo5dMEP_BbI06",
    title: "Steven Spielberg's West Side Story",
    youtubeID: "A5GJLwWiYSg",
    videoLength: "2:15",
    videoThumbnail: "http://i3.ytimg.com/vi/A5GJLwWiYSg/hqdefault.jpg",
    likes: "70K",
    views: "9.2M",
    category: "romance",
    channelName: "20th Century Studios",
    channelThumbnail:
      "https://yt3.ggpht.com/ytc/AKedOLS0_xUgI38v9jdvNVywBUODYhgnM0rU3_iJfD0ytQ=s48-c-k-c0x00ffffff-no-rj",
    channelLink: "https://www.youtube.com/channel/UC2-BeLxzUBSs0uSrmzWhJuQ",
    subscribers: "4.41M",
    description: "Directed by Academy Award® winner Steven Spielberg, from a screenplay by Pulitzer Prize and Tony Award® winner Tony Kushner, “West Side Story” tells the classic tale of fierce rivalries and young love in 1957 New York City.",
  },
];
